/**
 * Core writes its transaction summaries in Markdown: 84% of them name a party as
 * `[Aruwa Capital Management](https://aruwacapital.com/)`. Rendered as-is in a table cell
 * clipped to a few hundred pixels, the reader sees brackets and the start of a URL rather
 * than the sentence — the markup crowds out the words it was meant to decorate.
 *
 * So a cell shows the text without its markup. The link target is dropped rather than
 * followed: the row already links to the announcement, and a cell that is one long
 * sentence is not the place to bury more.
 *
 * Company descriptions carry no markup at all today. They go through this too, because
 * the cost is nothing and the day Core starts writing them the same way, they will read
 * correctly without anyone noticing they had to.
 */
export function plainText(value: string | null | undefined): string {
  if (!value) return ''
  return value
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}
